import React from "react";

import Navbar from "../../Components/Navbar";
import Banner from "./Banner";

function index() {
    return (
        <>
            <Navbar />
            <div className={"J"}>
                <Banner />
            </div>
        </>
    );
}

export default index;
